import styled from 'styled-components/native';

import { padding } from '@src/configuration/constants';

const Component = styled.ScrollView.attrs({
  contentContainerStyle: {
    padding,
    flex: 1,
    justifyContent: 'space-between',
  },
})``;

Component.displayName = 'AuthenticationScrollView';

export default Component;
